/**
 * @fileoverview Diálogo modal de "Observações do Contato" — reutiliza o componente
 * ContactNotes (compose + timeline) dentro de um Dialog moderno.
 * Paleta alinhada ao modal Gerenciar Etiquetas.
 */

import React from "react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";
import { ContactNotes } from "../ContactNotes";

import { X } from "lucide-react";
const useStyles = makeStyles((theme) => {
	const dark = theme.palette.type === "dark";
	return {
		dialog: {
			"& .MuiDialog-paper": {
				fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
				width: "min(480px, calc(100vw - 32px))",
				maxWidth: "calc(100vw - 32px)",
				maxHeight: "min(88vh, 720px)",
				borderRadius: 24,
				overflow: "hidden",
				background: dark
					? "linear-gradient(180deg, #171a20 0%, #111319 100%)"
					: "#ffffff",
				boxShadow: dark
					? "0 24px 80px rgba(0, 0, 0, 0.45)"
					: "0 24px 60px rgba(15, 23, 42, 0.12)",
				border: dark
					? "1px solid rgba(255, 255, 255, 0.08)"
					: "1px solid rgba(15, 23, 42, 0.08)",
				"& *": {
					fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
				},
			},
		},
		header: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: theme.spacing(2.5, 3),
			borderBottom: dark
				? "1px solid rgba(255, 255, 255, 0.06)"
				: "1px solid rgba(15, 23, 42, 0.08)",
		},
		headerText: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0 },
		title: {
			fontSize: "1.35rem",
			fontWeight: 700,
			color: dark ? "#f8fafc" : "#111827",
			lineHeight: 1.2,
		},
		subtitle: {
			fontSize: "0.82rem",
			color: dark ? "rgba(248, 250, 252, 0.6)" : "#6b7280",
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
		close: {
			color: dark ? "rgba(248, 250, 252, 0.72)" : "#6b7280",
		},
		content: {
			padding: theme.spacing(3),
			maxHeight: "calc(min(88vh, 720px) - 84px)",
			overflowY: "auto",
			...theme.scrollbarStylesSoft,
		},
	};
});

export default function ContactNotesDialog({ modalOpen, onClose, ticket }) {
	const classes = useStyles();

	if (!ticket) return null;

	const contactName = ticket.contact?.name;

	return (
		<Dialog
			open={!!modalOpen}
			onClose={onClose}
			className={classes.dialog}
			maxWidth={false}
		>
			<div className={classes.header}>
				<div className={classes.headerText}>
					<Typography className={classes.title}>
						{i18n.t("ticketOptionsMenu.appointmentsModal.title")}
					</Typography>
					{contactName && (
						<Typography className={classes.subtitle}>{contactName}</Typography>
					)}
				</div>
				<IconButton size="small" onClick={onClose} className={classes.close}>
					<X size={18} />
				</IconButton>
			</div>
			<div className={classes.content}>
				<ContactNotes ticket={ticket} />
			</div>
		</Dialog>
	);
}
